import { memo } from "react";
import { Control, FieldValues, Path } from "react-hook-form";
import LabelContainer from "./label-container";
import ModalSelect from "./modal-select";

type ModalSelectWithLabelProps<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  label: string;
  placeholder?: string;
  options: { value: string; name: string }[];
  disabled?: boolean;
  className?: string;
  error?: string;
  initialBreakpoint?: number;
  showErrorMessage?: boolean;
  breakpoints?: number[];
  theme?: "light" | "settings";
  renderModalContent?: (context: {
    value: unknown;
    options: { value: string; name: string }[];
    onSelect: (value: string) => void;
    close: () => void;
  }) => React.ReactNode;
};

function ModalSelectWithLabelInner<T extends FieldValues>({
  control,
  name,
  label,
  placeholder,
  options,
  disabled,
  className,
  error,
  initialBreakpoint,
  breakpoints,
  showErrorMessage = true,
  theme = "light",
  renderModalContent,
}: ModalSelectWithLabelProps<T>) {
  return (
    <LabelContainer
      label={label}
      htmlFor={name}
      error={error}
      showErrorMessage={showErrorMessage}
      className={className}
      theme={theme}
    >
      <ModalSelect
        control={control}
        name={name}
        placeholder={placeholder}
        options={options}
        disabled={disabled}
        initialBreakpoint={initialBreakpoint}
        breakpoints={breakpoints}
        theme={theme}
        renderModalContent={renderModalContent}
      />
    </LabelContainer>
  );
}

const ModalSelectWithLabel = memo(ModalSelectWithLabelInner) as typeof ModalSelectWithLabelInner;

export default ModalSelectWithLabel;
